export default {"src":"/_next/static/media/swift.757616d9.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};